import {apiInstance as Axios} from '../api/requestInterceptor';
import {generateQueryString} from '../utils';

//Location Types
const getLocationTypes = ({
  page = 1,
  sortBy = '',
  sortDirection = '',
  countryIds = '',
} = {}) => {
  return Axios.get(
    `/data/locationTypes?${generateQueryString({
      page,
      sortBy,
      sortDirection,
      countryIds,
    })}`,
  );
};

const getLocations = ({
  page = 1,
  perPage = 20,
  locationCategoryIds = '',
  productCategoryIds = '',
  locationTypeIds = '',
  openingHourFrom = '',
  openingHourTo = '',
  distanceInMiles = '',
  currentLatitude = 0,
  currentLongitude = 0,
  sortBy = '',
  sortDirection = 'asc',
  onlyCastrolCertified = false,
  countryIds = 0,
  isMiles = 'true',
  distanceInMilesOrKM = 0,
  text =''
} = {}) => {
  return Axios.get(
    `/data/locations?&${generateQueryString({
      page,
      perPage,
      locationCategoryIds,
      productCategoryIds,
      locationTypeIds,
      openingHourFrom,
      openingHourTo,
      distanceInMiles,
      currentLatitude,
      currentLongitude,
      sortBy,
      sortDirection,
      onlyCastrolCertified,
      countryIds: countryIds ? countryIds : null,
      isMiles,
      distanceInMilesOrKM,
      text
    })}`,
  );
};

const productClickLogs = (data: {
  productId: number;
  type: string;
  linkId?: number;
}) => {
  return Axios.post(`/data/productClickLogs`, data);
};

const getLocationCategories = ({page = 0} = {}) => {
  return Axios.get(
    `/data/locationCategories?${generateQueryString({
      page,
    })}`,
  );
};

const getProductCategories = ({page = 0} = {}) => {
  return Axios.get(
    `/data/productCategories?${generateQueryString({
      page,
    })}`,
  );
};

interface Form {
  name?: string;
  email?: string;
  contactNumber?: string;
  message?: string;
  promotionalCode?: string;
  signUpForCastrolPromotions?: boolean;
}
//
const postContact = (id: number, value: Form) => {
  return Axios.post(`/data/locations/${id}/contact`, value);
};

const postBook = (id: number, value: Form) => {
  return Axios.post(`/data/locations/${id}/book`, value);
};

const getCountries = () => {
  return Axios.get(`/data/countries?page=0`);
};

const getProduct = (id: number, isworkshopowner = false) => {
  let headers: any = {
    ...Axios.defaults.headers,
  }
  if (isworkshopowner) {
    headers = {
      ...headers,
      isWorkshopOwner: true
    }
  }
  if ('REACT_APP_EXTERNAL_NAME' in process.env) {
    headers = {
      ...headers,
      externalName: process.env.REACT_APP_EXTERNAL_NAME
    }
  }
  return Axios.get(`/products/${id}`, {headers});
};

const getLangs = () => {
  return Axios.get(`/data/languages`);
};

const getCountrySetting = () => {
  let headers: any = {
    ...Axios.defaults.headers,
  }
  if ('REACT_APP_EXTERNAL_NAME' in process.env) {
    headers = {
      ...headers,
      externalName: process.env.REACT_APP_EXTERNAL_NAME
    }
  }
  return Axios.get('/data/countrySettings/currentCountrySetting', {headers});
};

const getRecommendations = (id: string, isworkshopowner = false) => {
  let headers: any = {
    ...Axios.defaults.headers,
  }
  if (isworkshopowner) {
    headers = {
      ...headers,
      isWorkshopOwner: true
    }
  }
  if ('REACT_APP_EXTERNAL_NAME' in process.env) {
    headers = {
      ...headers,
      externalName: process.env.REACT_APP_EXTERNAL_NAME
    }
  }
  return Axios.get(
    `${process.env.REACT_APP_PROVIDER_URL}recommendations?vehicleId=${id}`,
    {headers}
  );
};

export {
  getLocationTypes,
  getLocations,
  productClickLogs,
  getLocationCategories,
  getProductCategories,
  postContact,
  postBook,
  getCountries,
  getProduct,
  getLangs,
  getCountrySetting,
  getRecommendations,
};
